module.exports = __webpack_public_path__ + "img/ctrl-pauli-x-root-stub-mid-+i.e527a638.svg";